import React, { useEffect, useState } from 'react'
import { sidebarNavBarStyles } from '../../styles/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import { FaCircle } from "react-icons/fa";
import axios from 'axios';
import ModalLoader from '../../common/Loader';
import ProfileBg from '../../common/ProfileBg';
import { toast } from 'react-toastify';

function Profile() {
  const classes = sidebarNavBarStyles();
  const baseUrl = "/dashboard";
  const [smallSize, setSmallSize] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userData = JSON.parse(localStorage.getItem('user'));
  const [appointmentData, setAppointmentData] = useState([]);
  const token = localStorage.getItem("token");
  const [appointmentOther, setAppointmentOther] = useState([]);
  const [hmoApp, setHmoApp] = useState([]);
  const [requestCode, setRequestCode] = useState([]);
  const [cardRequest, setCardRequest] = useState([]);
  const [dependent, setDependent] = useState([]);
  const [drugRefill, setDrugRefill] = useState([]);
  let isEnrollee = JSON.parse(localStorage.getItem("enrollee"));
  isEnrollee = isEnrollee?.insurance_no;
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  const [tab, setTab] = useState(1);
  const [step, setStep] = useState(1);

  const tabs = [
    { id: 1, label: 'My Appointment' },
    { id: 2, label: 'Appointment For Others' },
    ...(isEnrollee ? [
      { id: 3, label: 'Request Code' },
      { id: 4, label: 'Card Request' },
      { id: 5, label: 'Dependant' },
      { id: 6, label: 'Drug Refills' },
      { id: 7, label: 'Hospital Visit' }
    ] : [])
  ];



  const fetchHmoAppointment = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1/users/hmo/appointments`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          }
        }
      );
      let newdata = data?.data?.slice(0, 5);
      setHmoApp(newdata);
      setIsLoading(false);
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-right"
      });
    }
  }
  const fetchRequestCode = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1/users/enrollees/request-code`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          }
        }
      );
      let newdata = data?.data?.slice(0, 5);
      setRequestCode(newdata);
      setIsLoading(false);
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-right"
      });
    }
  }

  const fetchCardRequest = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1/users/enrollees/request-card`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          }
        }
      );
      let newdata = data?.data?.slice(0, 5);
      setCardRequest(newdata);
      setIsLoading(false);
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-right"
      });
    }
  }

  const fetchDependent = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1/users/dependants`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          }
        }
      );
      let newdata = data?.data?.dependants?.slice(0, 5);
      setDependent(newdata);
      setIsLoading(false);
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-right"
      });
    }
  }


  const fetchDrugRefill = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1/users/enrollees/drug-refills`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          }
        }
      );
      let newdata = data?.data?.slice(0, 5);
      setDrugRefill(newdata);
      setIsLoading(false);
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-right"
      });
    }
  }






  const fetchOtherAppointment = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1/plans/purchase-for-others`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          }
        }
      )
      let newdata = data?.data?.slice(0, 5);
      console.log(newdata);
      setAppointmentOther(newdata);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchOtherAppointment();
    if (isEnrollee) {
      fetchHmoAppointment();
      fetchRequestCode();
      fetchCardRequest();
      fetchDependent();
      fetchDrugRefill();
    }

  }, [tab])

  const fetchAppointment = async () => {
    setIsLoading(true);
    let type = 'upcoming';
    if (step == 2) {
      type = 'past';
    } else {
      type = 'upcoming';
    }
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1/appointments/history/${type}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          }
        })

      let newdata = data?.data?.data.slice(0, 5);
      setAppointmentData(newdata)
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchAppointment();
  }, [step]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
      if (windowSize[0] >= 765) {
        setSmallSize(false);
      } else {
        setSmallSize(true);
      }
    };
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [windowSize[0]]);


  return (
    <div className=' w-full  bg-white'>
      <ModalLoader visible={isLoading} />
      <ProfileBg />
      <div className='p-[20px]'>
         {/* Scrollable Tabs */}
        
        <div className='w-full flex flex-col md:flex-row'>
         
           <div className='w-full border-b flex flex-col whitespace-nowrap'>
          {tabs.map((t) => (
            <span
              key={t.id}
              className={`font-medium flex text-[12px] flex-wrap text-black border-b-2 ${tab === t.id ? 'border-[#324e6f]' : 'border-transparent'} cursor-pointer mb-4 `}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </span>
          ))}
        </div>
          <div className='bg-white drop-shadow-xl w-full md:ml-[20px] mt-[20px]'>
          {
            tab == 1 &&
            <div className='mt-[20px] px-2 flex justify-between  h-[100px] '>
              <div onClick={() => { setStep(1) }} className={`cursor-pointer w-full h-[50px] flex mr-[20px] md:mr-0 justify-center items-center ${step == 1 ? 'border-b-2   border-[#F7C657]' : 'border-none'}`}>Upcoming</div>
              <div onClick={() => { setStep(2) }} className={`cursor-pointer w-full h-[50px] flex justify-center items-center ${step == 2 ? 'border-b-2   border-[#F7C657]' : 'border-none'}`}>Past</div>
            </div>
          }
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: `${windowSize[0] >= 765 ? 650 : 200}`, border: 'none' }} aria-label="simple table">
                {
                  tab == 1 &&
                  <TableHead>
                    <TableRow>
                      <TableCell className='text-[#718096] hidden md:block font-bold' align="left">
                        <div className='font-bold'>Hospital</div>
                      </TableCell>
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] hidden md:block  font-bold' align="left">
                          <div className='font-bold'>Date</div>
                        </TableCell>}
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] font-bold' align="left">
                          <div className='font-bold'>
                            Time
                          </div>
                        </TableCell>
                      }
                      <TableCell className='text-[#718096] font-bold' align="left">
                        <div className='font-bold'>Status</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>}
                {
                  tab == 2 &&
                  <TableHead>
                    <TableRow>
                      <TableCell className='text-[#718096] hidden md:block font-bold' align="left">
                        <div className='font-bold'>Hospital</div>
                      </TableCell>
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] hidden md:block  font-bold' align="left">
                          <div className='font-bold'>Date</div>
                        </TableCell>}
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] font-bold' align="left">
                          <div className='font-bold'>
                            Time
                          </div>
                        </TableCell>
                      }
                      <TableCell className='text-[#718096] font-bold' align="left">
                        <div className='font-bold'>Name</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>}



                {
                  tab == 3 &&
                  <TableHead>
                    <TableRow>
                      {/* 
                      <TableCell className='text-[#718096] hidden md:block font-bold' align="left">
                        <div className='font-bold'>Request Date</div>
                      </TableCell>
                       */}
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] hidden md:block  font-bold' align="left">
                          <div className='font-bold'>Message</div>
                        </TableCell>}
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] font-bold' align="left">
                          <div className='font-bold'>
                            Hospital Name
                          </div>
                        </TableCell>
                      }
                      <TableCell className='text-[#718096] font-bold' align="left">
                        <div className='font-bold'>Status</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>}

                {
                  tab == 4 &&
                  <TableHead>
                    <TableRow>
                      <TableCell className='text-[#718096] hidden md:block font-bold' align="left">
                        <div className='font-bold'>Address</div>
                      </TableCell>
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] hidden md:block  font-bold' align="left">
                          <div className='font-bold'>Card Collected</div>
                        </TableCell>}

                      <TableCell className='text-[#718096] font-bold' align="left">
                        <div className='font-bold'>Status</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>}
                {
                  tab == 5 &&
                  <TableHead>
                    <TableRow>
                      <TableCell className='text-[#718096] hidden md:block font-bold' align="left">
                        <div className='font-bold'>Date of Birth</div>
                      </TableCell>
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] hidden md:block  font-bold' align="left">
                          <div className='font-bold'>Name</div>
                        </TableCell>}

                      <TableCell className='text-[#718096] font-bold' align="left">
                        <div className='font-bold'>Relationship</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>}

                {
                  tab == 6 &&
                  <TableHead>
                    <TableRow>
                      {/* <TableCell className='text-[#718096] hidden md:block font-bold' align="left">
                        <div className='font-bold'>Request Date</div>
                      </TableCell> */}
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] hidden md:block  font-bold' align="left">
                          <div className='font-bold'>Request Reason</div>
                        </TableCell>}
                      <TableCell className='text-[#718096] font-bold' align="left">
                        <div className='font-bold'>Medication Name</div>
                      </TableCell>

                      <TableCell className='text-[#718096] font-bold' align="left">
                        <div className='font-bold'>Status</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>}

                {
                  tab == 7 &&
                  <TableHead>
                    <TableRow>
                      <TableCell className='text-[#718096] hidden md:block font-bold' align="left">
                        <div className='font-bold'>Appointment Date</div>
                      </TableCell>
                      {windowSize[0] >= 765 &&
                        <TableCell className='text-[#718096] hidden md:block  font-bold' align="left">
                          <div className='font-bold'>Comment</div>
                        </TableCell>}
                      <TableCell className='text-[#718096] font-bold' align="left">
                        <div className='font-bold'>Hospital Name</div>
                      </TableCell>

                      <TableCell className='text-[#718096] font-bold' align="left">
                        <div className='font-bold'>Status</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>}
                {
                  tab == 1 &&
                  
                  <TableBody>
                    {
                      appointmentData?.map((d, index) => {
                        return (
                          <TableRow
                            key={1}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell className='hidden md:block' component="th" scope="row">
                              {d?.hospital_name}
                            </TableCell>
                            {windowSize[0] >= 765 && <TableCell className='hidden md:block' align="left">{new Date(d?.appointment_date).toLocaleDateString()}</TableCell>}
                            {windowSize[0] >= 765 && <TableCell className="hidden md:block" align="left">{new Date(d?.appointment_date).toLocaleTimeString()}</TableCell>}
                            {
                              <TableCell className="hidden md:block" align="left">
                                <div className='flex items-center'>
                                  <FaCircle color="#EFDB6F" /> <span className='ml-[10px]'>{d?.status}</span>
                                </div>
                              </TableCell>}

                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                }
                {
                  tab == 2 &&
                  <TableBody>
                    {
                      appointmentOther?.map((d, index) => {
                        return (
                          <TableRow
                            key={1}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >

                            <TableCell className='hidden md:block' component="th" scope="row">
                              {d?.data?.hospital_name}
                            </TableCell>
                            {windowSize[0] >= 765 && <TableCell className='hidden md:block' align="left">{new Date(d?.data?.appointment_date).toLocaleDateString()}</TableCell>}
                            {windowSize[0] >= 765 && <TableCell className="hidden md:block" align="left">{new Date(d?.data?.appointment_date).toLocaleTimeString()}</TableCell>}
                            {
                              <TableCell className="hidden md:block" align="left">
                                <div className='flex items-center'>
                                  <span className='ml-[10px] font-semibold'>{d?.data?.first_name}{' '}{d?.data?.last_name}</span>
                                </div>
                              </TableCell>}
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                }

                {
                  tab == 3 &&
                  <TableBody>
                    {
                      requestCode.map((data, i) => {
                        return (
                          <TableRow
                            key={1}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >

                            {/* <TableCell className='hidden md:block' component="th" scope="row">
                              {data.appointment_date}
                            </TableCell> */}
                            {windowSize[0] >= 765 && <TableCell className='hidden md:block' align="left">{data.request_message}</TableCell>}
                            {windowSize[0] >= 765 && <TableCell className="hidden md:block" align="left">{data.hospital_name}</TableCell>}
                            {
                              <TableCell className="hidden md:block" align="left">
                                <div className='flex items-center'>
                                  <FaCircle color="#EFDB6F" /> <span className='ml-[10px]'>{data.status}</span>
                                </div>
                              </TableCell>}
                          </TableRow>
                        )
                      })



                    }
                  </TableBody>
                }

                {
                  tab == 4 &&
                  <TableBody>

                    {cardRequest.map((data, i) => {
                      return (
                        <TableRow
                          key={1}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >

                          <TableCell className='hidden md:block' component="th" scope="row">
                            {data.address}
                          </TableCell>
                          {windowSize[0] >= 765 && <TableCell className='hidden md:block' align="left">{data?.card_collected ? 'Yes' : 'No'}</TableCell>}

                          {
                            <TableCell className="hidden md:block" align="left">
                              <div className='flex items-center'>
                                <FaCircle color="#EFDB6F" /> <span className='ml-[10px]'>{data.status}</span>
                              </div>
                            </TableCell>}
                        </TableRow>
                      )
                    })



                    }
                  </TableBody>
                }

                {
                  tab == 5 &&
                  <TableBody>
                    {
                      dependent.map((data, i) => {
                        return (
                          <TableRow
                            key={1}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >

                            <TableCell className='hidden md:block' component="th" scope="row">
                              {data?.dob}
                            </TableCell>
                            {windowSize[0] >= 765 && <TableCell className='hidden md:block' align="left">{data?.first_name}{''}{data?.last_name}</TableCell>}
                            {
                              <TableCell className="hidden md:block" align="left">
                                <div className='flex items-center'>
                                  <FaCircle color="#EFDB6F" /> <span className='ml-[10px]'>{data?.relationship}</span>
                                </div>
                              </TableCell>}
                          </TableRow>
                        )
                      })


                    }
                  </TableBody>
                }

                {
                  tab == 6 &&
                  <TableBody>
                    {
                      drugRefill.map((data, i) => {
                        return (
                          <TableRow
                            key={1}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >

                            {/* <TableCell className='hidden md:block' component="th" scope="row">
                              14/03/2025
                            </TableCell> */}
                            {windowSize[0] >= 765 && <TableCell className='hidden md:block' align="left">	{data.reason}</TableCell>}
                            {windowSize[0] >= 765 && <TableCell className='hidden md:block' align="left">	{data.drug_name}</TableCell>}

                            {
                              <TableCell className="hidden md:block" align="left">
                                <div className='flex items-center'>
                                  <FaCircle color="#EFDB6F" /> <span className='ml-[10px]'>{data.status}</span>
                                </div>
                              </TableCell>}
                          </TableRow>
                        )
                      })

                    }
                  </TableBody>
                }

                {
                  tab == 7 &&
                  <TableBody>
                    {
                      hmoApp.map((data, i) => {
                        return (
                          <TableRow
                            key={1}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >

                            <TableCell className='hidden md:block' component="th" scope="row">
                              {data.appointment_date}
                            </TableCell>
                            {windowSize[0] >= 765 && <TableCell className='hidden md:block' align="left">	{data.comment}</TableCell>}
                            {windowSize[0] >= 765 && <TableCell className='hidden md:block' align="left">	{data.hospital_name}</TableCell>}

                            {
                              <TableCell className="hidden md:block" align="left">
                                <div className='flex items-center'>
                                  <FaCircle color="#EFDB6F" /> <span className='ml-[10px]'>{data.status}</span>
                                </div>
                              </TableCell>}
                          </TableRow>
                        )
                      })

                    }
                  </TableBody>
                }
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile